import { config } from 'config';

export function isOldTransaction(createdAt: string) {
  const transactionDate = new Date(createdAt);
  const newTransactionsDate = new Date(config.reports.minTransactionDetailDay);
  return transactionDate.getTime() <= newTransactionsDate.getTime();
}
